"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _setConfig = _interopRequireDefault(require("../utils/setConfig"));
var _sentryCapture = _interopRequireDefault(require("../sentry-capture"));
var _vue = _interopRequireDefault(require("vue"));
var _asyncLoadingSentry = _interopRequireDefault(require("../utils/asyncLoadingSentry"));
var _globalMethod = _interopRequireDefault(require("../common/globalMethod"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @function
 * @name SentryVueInit - vue版前端错误异常上报安装
 * @desc 前端配置错误异常上报及主动上报函数封装
 * @param {string} url 申请的异常上报系统地址
 * @param {object} cfg 配置
 * @param {boolean} cfg.senddev 是否在dev环境发送
 * @example
 * import { SentryInit } from '@zz-common/sentry';
 * 
 * SentryVueInit('url')
 * 
 * // sentry  接入例子
  useSentry() {
    tryCatch(() => {
      SentryVueInit('url')
    })
  }
  
  // 已经封装到sentry包中，这个不用在业务代码里加了!!!
  Vue.config.errorHandler = (err, vm, info) => {
    SentryCapture(err, 'error')
  }
 */
var _default = exports.default = function _default(url, cfg) {
  if (url) {
    (0, _setConfig.default)(function (config) {
      (0, _asyncLoadingSentry.default)(function (WSentry) {
        if (WSentry && url && !WSentry.loadedStatus) {
          var opt = _objectSpread({
            dsn: url
          }, config || {});
          WSentry.init(opt);
        }
      }, config);
    }, cfg || {});
  }
  try {
    if (_vue.default) {
      /**
       * 从 2.2.0 起，这个钩子也会捕获组件生命周期钩子里的错误。同样的，当这个钩子是 undefined 时，被捕获的错误会通过 console.error 输出而避免应用崩
       * 从 2.4.0 起，这个钩子也会捕获 Vue 自定义事件处理函数内部的错误了
       * 从 2.6.0 起，这个钩子也会捕获 v-on DOM 监听器内部抛出的错误。另外，如果任何被覆盖的钩子或处理函数返回一个 Promise 链 (例如 async 函数)，则来自其 Promise 链的错误也会被处理
       * 在2.9.8版本Vue.config.errorHandler 报错 "toJSON"
       * 在2.9.8版本errorCaptured不生效
       * uni-app自定义的onError应用生命周期：
       * 在2.6.11版本算正常, 真机
       * {
       *   1.err: 报错描述"ReferenceError: sd is not defined"
       *   2.vm: 报错信息，页面文件page对象，等等
       *   3.info: 报错行数info.line, 生命周期
       * }
       * 在2.9.8版本只有err可以返回参数vm,info均为缺省值
       * 
       * vue3 Vue.onErrorCaptured 捕获错误
       */
      if (_vue.default !== null && _vue.default !== void 0 && _vue.default.config) {
        _vue.default.config.errorHandler = function (err, _, info) {
          try {
            var glob = new _globalMethod.default();
            glob === null || glob === void 0 || glob.mergeConsoleErrorInfo({
              'vue全局异常监控': {
                err: err,
                info: info
              }
            });
          } catch (e) {}
          // 过滤接口异常，重复了
          if (!(info.indexOf('v-on handler (Promise/async)') > -1)) {
            return (0, _sentryCapture.default)("\u5168\u5C40\u5F02\u5E38\u76D1\u63A7\uFF1A".concat(err, " \u5176\u4ED6\u4FE1\u606F\uFF1A").concat(info), 'error');
          }
          return false;
        };
      }
    }
  } catch (e) {}
};